export default "__VITE_ASSET__DfIz0KE0__"